import Bind from 'bind.js';
import marked from 'marked';
import UrlSafeString from 'url-safe-string';
import YoutubeUrl from 'youtube-url';
import embed from "embed-video";

export default class Blog {
  constructor(options) {
    this.parentElement = options.parentElement;
    this.data = options.data;
    this.addTemplate();
    this.addContent();
  }

  addTemplate() {
    let template = `
      <div class="blog-posts">
      </div>
    `

    this.parentElement.innerHTML = template;
  }

  addContent() {
    let parentElement = this.parentElement;
    this.editor = Bind(
      {
        posts: this.data.get('posts').toJS(),
        selectedPost: -1,
        index: 0
      },
      {
        posts: {
          dom: '.blog-posts',
          callback: function() {
            let posts = parentElement.getElementsByClassName('post');

            for (var i=0; i < posts.length; i++) {
              let altClass = (i % 2) ? "even" : "odd";
              posts[i].className += " " + altClass;

              if (i > 0) {
                let seperatorClass = (i % 2) ? "lightmediumarc" : "mediumarc";

                let seperator = posts[i].getElementsByClassName('seperator')[0];

                seperator.className += " " + seperatorClass;
              }
            }
          },
          transform: function(post, bindObj) {
            var renderer = new marked.Renderer();

            renderer.link = (href, title, text) => {
              var valid = YoutubeUrl.valid(href);

              if (valid) {
                return embed(href);
              } else {
                return '<a href="'+href+'" target="_blank">' + href + '</a>';
              }
            }

            let content = marked(post.content, { renderer: renderer });

            var tagGenerator = new UrlSafeString();
            var tag = tagGenerator.generate(post.title);

            return `<div class="post">
              <div class="span12 seperator"></div>
              <div class="span12">
                <div class="post-content">
                  <span class="span12 title">${post.title}</span>
                  <div class="span2 meta">
                    Author: <span class="author">${post.author}</span><br/>
                    <span class="date">${post.date}</span>
                  </div>
                  <div class="span10 post-text">${content}


                  <div class="fb-comments"
                    data-href="${window.location.origin}/blog.html#${tag}"
                    data-width="100%"
                    data-order-by="Top"
                    data-numposts="3"></div>
                  </div>
                </div>
              </div>
              <div style="clear:both;"></div>
            </div>`;
          }
        },
        selectedPost: function(sel) {
          if (sel > -1) {
            let postContainer = document.getElementsByClassName('blog-posts')[0];
            let posts = document.getElementsByClassName('post');

            if (posts.length > 0) {
              window.scrollTo(0, posts[sel].offsetTop + postContainer.parentNode.offsetTop);
            }
          }
        }
      }
    )
  }

  reRender(data) {
    this.data = data;

    this.editor.index = 0;
    this.editor.selectedPost = data.get('selectedPost');

    if (this.editor.posts.length !== data.get('posts').count()) {
      this.editor.posts = data.get('posts').toJS();
    } else {
      this.editor.posts[this.editor.selectedPost].title = data.get('posts').get(this.editor.selectedPost).get('title');
      this.editor.posts[this.editor.selectedPost].content = data.get('posts').get(this.editor.selectedPost).get('content');
      this.editor.posts[this.editor.selectedPost].author = data.get('posts').get(this.editor.selectedPost).get('author');
      this.editor.posts[this.editor.selectedPost].date = data.get('posts').get(this.editor.selectedPost).get('date');
    }


  }
}



// WEBPACK FOOTER //
// ./src/renderers/Blog.js